import { render } from "./App.vue?vue&type=template&id=23ff75d4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=23ff75d4&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__